import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=0a3ffc4f"
import script from "./CancelButton.vue?vue&type=script&lang=js"
export * from "./CancelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports